import { dashboardRoutes } from "./modules/dashboard";
import { farmRoutes } from "./modules/farm";
import { inventoryRoutes } from "./modules/inventory";
import { masterRoutes } from "./modules/master";
import { purchasingRoutes, purchasingPrintRoutes } from "./modules/purchasing";
import { salesRoutes, salesPrintRoutes } from "./modules/sales";
import { accountingRoutes, accountingPrintRoutes } from "./modules/accounting";
import { financeRoutes } from "./modules/finance";

/**
 * Route Configuration
 *
 * Structure:
 * - path: URL path (required for pages)
 * - title: Display name for Sidebar/Breadcrumbs
 * - component: React Component to render
 * - permission: Permission string required to view (null = public to auth users)
 * - type: 'menu' (default) | 'section' | 'hidden'
 * - icon: React Node for Sidebar
 * - children: Array of nested routes
 */
export const routes = [
    dashboardRoutes,
    masterRoutes,
    farmRoutes,
    purchasingRoutes,
    salesRoutes,
    inventoryRoutes,
    financeRoutes,
    accountingRoutes,
];

// Print routes (rendered outside AdminLayout)
export const printRoutes = [...salesPrintRoutes, ...purchasingPrintRoutes, ...accountingPrintRoutes];

// Helper to flatten routes for the Router (excluding sections)
export const getFlattenedRoutes = () => {
    const flatten = (items) => {
        let flat = [];
        items.forEach((item) => {
            if (item.component) {
                flat.push(item);
            }
            if (item.items) {
                flat = [...flat, ...flatten(item.items)];
            }
            if (item.children) {
                // Ensure children that are pages are also included if they have components (future proofing)
                // Current structure implies children might just be sub-menus, but if they have components they are routes
                flat = [...flat, ...flatten(item.children)];
            }
        });
        return flat;
    };

    return flatten(routes);
};
